import { render, staticRenderFns } from "./property-create.vue?vue&type=template&id=08187a0d&"
import script from "./property-create.vue?vue&type=script&lang=js&"
export * from "./property-create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports